var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4615 5.5C12.4615 7.13561 11.1356 8.46154 9.5 8.46154C7.86439 8.46154 6.53846 7.13561 6.53846 5.5C6.53846 3.86439 7.86439 2.53846 9.5 2.53846C11.1356 2.53846 12.4615 3.86439 12.4615 5.5ZM13.0783 9.6769C14.2547 8.66819 15 7.17113 15 5.5C15 2.46243 12.5376 0 9.5 0C6.46243 0 4 2.46243 4 5.5C4 7.17113 4.74531 8.66819 5.92165 9.6769C2.4485 11.0157 0 14.2453 0 18.0166H2.59091C2.59091 14.4016 5.68421 11.4711 9.5 11.4711C13.3158 11.4711 16.4091 14.4016 16.4091 18.0166H19C19 14.2453 16.5515 11.0157 13.0783 9.6769Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c60452d190a8bad0fba840a8e23d9487.svg";
export { ForwardRef as ReactComponent };